import React from 'react';
import { Button, Typography, withStyles } from '@material-ui/core';
import WebsiteSVG from '../layout/svg/WebsiteSVG';

const styles = {
  wrapper: {
    display: 'flex',
    marginTop: '15vh',
    maxWidth: 600,
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  header: {
    marginBottom: '14px',
    marginTop: 0,
    color: '#212322',
    fontSize: '24px',
  },
  subHeader: {
    margin: 0,
    marginBottom: '34px',
    color: 'rgba(33,35,34,0.5)',
    fontSize: '13px',
    fontWeight: 400,
  },
  svg: {
    marginBottom: '31px',
  },
  button: {
    fontWeight: 500,
  },
  withoutMargin: {
    marginTop: 0,
    padding: '16px',
  },
};

const NoItemsPage = withStyles(styles)(({ classes, title, subtitle, href, isBlank, buttonText, withIcon = true, withMargin = true, children }) => (
  <div className={`${classes.wrapper} ${withMargin ? '' : classes.withoutMargin}`}>
    {withIcon ? <WebsiteSVG className={classes.svg}/> : false}
    <Typography variant="h2" className={classes.header}>{title}</Typography>
    {subtitle && <Typography variant="subtitle2" className={classes.subHeader}>{subtitle}</Typography>}
    {children || <Button color="secondary"
      variant="contained"
      href={href}
      className={classes.button}
      target={isBlank ? '_blank' : ''}>
      {buttonText}
    </Button>}
  </div>
));

export default NoItemsPage;
